import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useFasePDP } from '../../../../services/enum/useFasePDP';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePlataformaPDP } from '../../../../services/enum/usePlataformaPDP';
import { useStatusPDP } from '../../../../services/enum/useStatusPDP';
import { useStatusPublicacaoPDP } from '../../../../services/enum/useStatusPublicacaoPDP';
import { useStatusVigenciaPDP } from '../../../../services/enum/useStatusVigenciaPDP';
import { getAllPdp } from '../../../../services/produtosDAF/pdpService';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../utils/functions';
import subAbas from '../subabas';
import {
  headersPDPs,
  valoresExibidosOffCanvasPDPs as valoresExibidos,
  fieldObjectPDPs as fieldObject,
} from './auxiliarPDPs';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { ENTITY } from '../../../../utils/entityNames';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Contrato;

const PdpIndex: React.FC = () => {
  const CACHE_KEY = 'cachedPDPs';
  const CACHE_EXPIRATION = 60 * 60 * 1000;

  const statusPublicacaoPDP = useStatusPublicacaoPDP();
  const statusVigenciaPDP = useStatusVigenciaPDP();
  const statusPDP = useStatusPDP();
  const plataformaPDP = usePlataformaPDP();
  const fasePDP = useFasePDP();

  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Contratos')
      ?.value || '0',
  );

  // Verificar permissões para ações
  const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    statusVigencia: 0,
    statusPdp: 0,
    faseAtual: 0,
    plataforma: 0,
    produtosDAF: '',
  });
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const cachedData = localStorage.getItem(CACHE_KEY);
      const now = new Date().getTime();

      // Verifica se há cache válido
      if (cachedData) {
        const { timestamp, data } = JSON.parse(cachedData);
        const timeDifference = now - timestamp;

        if (timeDifference < CACHE_EXPIRATION) {
          setData(data); // Usa os dados do cache sem buscar na API
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }

      // Busca da API apenas se não houver cache ou se estiver expirado
      const registros = await getAllPdp();
      setData(registros);
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ timestamp: now, data: registros }),
      );
    } catch (error) {
      console.error('❌ Erro ao obter dados:', error);
    }
  };

  // Chama o fetchData no primeiro render
  useEffect(() => {
    fetchData();
  }, []);

  //Dados da tabela
  const filteredData = data.filter((item) => {
    const statusVigenciaLabel =
      statusVigenciaPDP[item.statusVigencia]?.label || 'Não informado';
    const statusPdpLabel = statusPDP[item.statusPdp]?.label || 'Não informado';
    const faseAtualLabel = fasePDP[item.faseAtual]?.label || 'Não informado';
    const plataformaLabel =
      plataformaPDP[item.plataforma]?.label || 'Não informado';

    return (
      (formFiltros.statusVigencia === 0 ||
        statusVigenciaLabel ===
          statusVigenciaPDP[formFiltros.statusVigencia]?.label) &&
      (formFiltros.statusPdp === 0 ||
        statusPdpLabel === statusPDP[formFiltros.statusPdp]?.label) &&
      (formFiltros.faseAtual === 0 ||
        faseAtualLabel === fasePDP[formFiltros.faseAtual]?.label) &&
      (formFiltros.plataforma === 0 ||
        plataformaLabel === plataformaPDP[formFiltros.plataforma]?.label) &&
      (formFiltros.produtosDAF === '' ||
        item.produtosDAF
          ?.toLowerCase()
          .includes(formFiltros.produtosDAF.toLowerCase()))
    );
  });

  const tableData = filteredData.map((item) => {
    const statusVigenciaLabel =
      statusVigenciaPDP[item.statusVigencia]?.label || '-';
    const statusPdpLabel = statusPDP[item.statusPdp]?.label || '-';

    const statusVigenciaBackgroundColor =
      statusVigenciaLabel === 'Extinta'
        ? 'red'
        : statusVigenciaLabel === 'Vigente'
          ? 'lightgreen'
          : '';

    const statusVigenciaText =
      statusVigenciaLabel === 'Extinta'
        ? 'white'
        : statusVigenciaLabel === 'Vigente'
          ? 'black'
          : '';

    const statusPdpBackgroundColor =
      statusPdpLabel === 'Ativa'
        ? 'lightgreen'
        : statusPdpLabel === 'Suspensa'
          ? 'yellow'
          : '';

    const statusPdpText = 'black';

    const demandaPdp =
      item.demanda != null ? `${item.demanda.toFixed(0)}%` : '—';

    return {
      id: item.id,
      idPdp: item.idPdp,
      statusVigencia: (
        <div style={{ textAlign: 'left', marginLeft: '-10px' }}>
          <span
            style={{
              backgroundColor: statusVigenciaBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: statusVigenciaText,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusVigenciaLabel}
          </span>
        </div>
      ),
      statusPdp: (
        <div style={{ textAlign: 'left', marginLeft: '-10px' }}>
          <span
            style={{
              backgroundColor: statusPdpBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: statusPdpText,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusPdpLabel}
          </span>
        </div>
      ),
      faseAtual: fasePDP[item.faseAtual]?.label || '-',
      plataforma: plataformaPDP[item.plataforma]?.label || '-',
      demanda: <div style={{ textAlign: 'center' }}>{demandaPdp}</div>,
      produtosDAF: item.produtosDAF || '—',
    };
  });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => {
    // Definindo cores de fundo e texto com base no status da vigência
    let statusPublicacaoBackgroundColor = '';
    let statusPublicacaoText = '';
    const statusPublicacao =
      statusPublicacaoPDP[item.statusPublicacao]?.label || '-';

    if (statusPublicacao === 'Não Publicado') {
      statusPublicacaoBackgroundColor = 'red';
      statusPublicacaoText = 'white';
    } else if (statusPublicacao === 'Publicado') {
      statusPublicacaoBackgroundColor = 'lightgreen';
      statusPublicacaoText = 'black';
    }

    // Definindo cores de fundo e texto com base no status da vigência
    let statusVigenciaBackgroundColor = '';
    let statusVigenciaText = '';
    const statusVigencia = statusVigenciaPDP[item.statusVigencia]?.label || '-';

    if (statusVigencia === 'Extinta') {
      statusVigenciaBackgroundColor = 'red';
      statusVigenciaText = 'white';
    } else if (statusVigencia === 'Vigente') {
      statusVigenciaBackgroundColor = 'lightgreen';
      statusVigenciaText = 'black';
    }

    // Definindo cores de fundo e texto com base no status ativo
    let statusAtivoPDPBackgroundColor = '';
    let statusAtivoPDPText = '';
    const statusAtivoPDP = statusPDP[item.statusPdp]?.label || '-';

    if (statusAtivoPDP === 'Suspensa') {
      statusAtivoPDPBackgroundColor = 'yellow';
      statusAtivoPDPText = 'black';
    } else if (statusAtivoPDP === 'Ativa') {
      statusAtivoPDPBackgroundColor = 'lightgreen';
      statusAtivoPDPText = 'black';
    }

    const demandaPdp =
      item.demanda != null ? `${item.demanda.toFixed(0)}%` : '—';

    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      idPdp: item.idPdp,
      termoCompromisso: item.termoCompromisso,
      produtosDAF: item.produtosDAF || '—',
      faseAtual: fasePDP[item.faseAtual]?.label || '-',
      dataInicioFaseII: formatDateSimp(item.dataInicioFaseII),
      dataInicioFaseIII: formatDateSimp(item.dataInicioFaseIII),
      plataforma: plataformaPDP[item.plataforma]?.label || '-',
      demanda: demandaPdp,
      separadorProdutos: '',
      statusPublicacao: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusPublicacaoBackgroundColor,
              borderRadius: '8px',
              padding: '8px',
              color: statusPublicacaoText,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusPublicacao}
          </span>
        </div>
      ),
      dataPublicacao: formatDateSimp(item.dataPublicacao),
      statusVigencia: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusVigenciaBackgroundColor,
              borderRadius: '8px',
              padding: '8px',
              color: statusVigenciaText,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusVigencia}
          </span>
        </div>
      ),
      statusPdp: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusAtivoPDPBackgroundColor,
              borderRadius: '8px',
              padding: '8px',
              color: statusAtivoPDPText,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusAtivoPDP}
          </span>
        </div>
      ),
      separadorStatus: '',
      instituicaoPublica: item?.instituicaoPublica || 'Não informado',
      parceiroPrivadoNacional: item?.parceiroPrivadoNacional || 'Não informado',
      parceiroPrivadoInternacional:
        item?.parceiroPrivadoInternacional || 'Não informado',
      entidadeIfa: item?.entidadeIfa || 'Não informado',

      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'level' || name === 'statusDesenvolvimento') {
      // Permitir somente números, '<', '>', ou uma combinação destes com números
      if (
        /^[0-9]*$/.test(value) ||
        value === '<' ||
        value === '>' ||
        /^[<>][0-9]+$/.test(value)
      ) {
        setFormFiltros((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === 'interfaceSisAf' || name === 'moduloSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      statusVigencia: 0,
      statusPdp: 0,
      faseAtual: 0,
      plataforma: 0,
      produtosDAF: '',
    });
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    idPdp: string;
    termoCompromisso: string;
    produtosDAF: string;
    faseAtual: any;
    dataInicioFaseII: string;
    dataInicioFaseIII: string;
    plataforma: any;
    demanda: string;
    statusPublicacao: any;
    dataPublicacao: string;
    statusVigencia: any;
    statusPdp: any;
    instituicaoPublica: string;
    parceiroPrivadoNacional: string;
    parceiroPrivadoInternacional: string;
    entidadeIfa: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        idPdp: item.idPdp,
        termoCompromisso: item.termoCompromisso,
        produtosDAF: item.produtosDAF || '—',
        faseAtual: fasePDP[item.faseAtual]?.label || '-',
        dataInicioFaseII: formatDateSimp(item.dataInicioFaseII),
        dataInicioFaseIII: formatDateSimp(item.dataInicioFaseIII),
        plataforma: plataformaPDP[item.plataforma]?.label || '-',
        demanda: item.demanda,
        statusPublicacao:
          statusPublicacaoPDP[item.statusPublicacao]?.label || '-',
        dataPublicacao: formatDateSimp(item.dataPublicacao),
        statusVigencia: statusVigenciaPDP[item.statusVigencia]?.label || '-',
        statusPdp: statusPDP[item.statusPdp]?.label || '-',
        instituicaoPublica: item?.instituicaoPublica || 'Não informado',
        parceiroPrivadoNacional:
          item?.parceiroPrivadoNacional || 'Não informado',
        parceiroPrivadoInternacional:
          item?.parceiroPrivadoInternacional || 'Não informado',
        entidadeIfa: item?.entidadeIfa || 'Não informado',

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const filteredDataForExport = data.filter((item) => {
    const statusVigenciaLabel =
      statusVigenciaPDP[item.statusVigencia]?.label || 'Não informado';
    const statusPdpLabel = statusPDP[item.statusPdp]?.label || 'Não informado';
    const faseAtualLabel = fasePDP[item.faseAtual]?.label || 'Não informado';
    const plataformaLabel =
      plataformaPDP[item.plataforma]?.label || 'Não informado';

    return (
      (formFiltros.statusVigencia === 0 ||
        statusVigenciaLabel ===
          statusVigenciaPDP[formFiltros.statusVigencia]?.label) &&
      (formFiltros.statusPdp === 0 ||
        statusPdpLabel === statusPDP[formFiltros.statusPdp]?.label) &&
      (formFiltros.faseAtual === 0 ||
        faseAtualLabel === fasePDP[formFiltros.faseAtual]?.label) &&
      (formFiltros.plataforma === 0 ||
        plataformaLabel === plataformaPDP[formFiltros.plataforma]?.label) &&
      (formFiltros.produtosDAF === '' ||
        item.produtosDAF
          ?.toLowerCase()
          .includes(formFiltros.produtosDAF.toLowerCase()))
    );
  });

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="200px">
              <SelectInput
                name="statusVigencia"
                options={statusVigenciaPDP}
                label="Vigência"
                value={formFiltros.statusVigencia}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="200px">
              <SelectInput
                name="statusPdp"
                options={statusPDP}
                label="Status PDP"
                value={formFiltros.statusPdp}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="200px">
              <SelectInput
                name="faseAtual"
                options={fasePDP}
                label="Fase Atual"
                value={formFiltros.faseAtual}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="200px">
              <SelectInput
                name="plataforma"
                options={plataformaPDP}
                label="Plataforma"
                value={formFiltros.plataforma}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol>
              <Input
                id="produtosDAF"
                name="produtosDAF"
                value={formFiltros.produtosDAF}
                label="Produtos DAF"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersPDPs}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          tituloCanvas="PDPs"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          downloadDisabled={!canDownload}
          inserir
          inserirDisabled={!canInsert}
          onClickInserir={handleClickInserir}
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(filteredDataForExport),
              valoresExibidos,
              fieldObject,
              'sisaf_pdps.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default PdpIndex;
